/**
 * @returns {boolean} whether the backend said the password is not acceptable.
 */
export default function (err) {
  const passwordApiError = err.response?.data?.errors?.password?.[0];
  if (passwordApiError) {
    this.error = passwordApiError;
    this.stage = 'password';
    return true;
  }
  return false
}
